import { Link, useLocation, useNavigate } from "react-router-dom";
import { Phone, Heart, Facebook, Instagram } from "lucide-react";
import { BRAND, SOCIALS } from "../data/restaurant";
import logo from "../assets/pattista-logo.png";

export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();

  const goSection = (e, href) => {
    if (location.pathname !== "/") {
      e.preventDefault();
      navigate("/", { state: { scrollTo: href } });
    }
  };

  return (
    <footer data-testid="footer-section" className="grain relative overflow-hidden bg-jet pb-10 pt-20 text-cream">
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6">
        <div className="flex flex-col items-center gap-8 text-center">
          <a href="#top" onClick={(e) => goSection(e, "#top")} data-testid="footer-logo" aria-label="Pattista home">
            <img src={logo} alt="Pattista logo" className="h-24 w-24 rounded-full border-[3px] border-amber/60 object-cover sm:h-28 sm:w-28" />
          </a>
          <p className="flex items-center gap-2 font-hand text-3xl font-bold text-sunshine sm:text-4xl">
            {BRAND.signoff}
            <Heart className="h-6 w-6 fill-crimson text-crimson" aria-hidden="true" />
          </p>
          <a
            href={BRAND.phoneHref}
            data-testid="footer-call-cta"
            className="inline-flex items-center gap-2 rounded-full border-[3px] border-cream bg-crimson px-7 py-3.5 font-display text-base font-extrabold uppercase text-cream shadow-[6px_6px_0_0_#FFB923] transition-all duration-200 hover:-translate-y-1 hover:shadow-[10px_10px_0_0_#FFB923]"
          >
            <Phone className="h-5 w-5" aria-hidden="true" />
            Call to Order · {BRAND.phoneDisplay}
          </a>
          <div className="flex items-center justify-center gap-3" data-testid="footer-socials">
            {SOCIALS.map((s) => (
              <a
                key={s.name}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Pattista on ${s.name}`}
                data-testid={s.testid}
                className="inline-flex h-12 w-12 items-center justify-center rounded-full border-[3px] border-cream/40 bg-cream/5 text-cream transition-all duration-200 hover:-translate-y-1 hover:border-amber hover:bg-amber hover:text-jet"
              >
                {s.icon === "facebook" ? <Facebook className="h-5 w-5" aria-hidden="true" /> : <Instagram className="h-5 w-5" aria-hidden="true" />}
              </a>
            ))}
          </div>
          <nav aria-label="Footer" className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
            <Link
              to="/menu"
              data-testid="footer-link-menu"
              className="font-display text-sm font-extrabold uppercase tracking-wide text-cream/80 transition-colors hover:text-sunshine"
            >
              Menu
            </Link>
            <a
              href="#deals"
              data-testid="footer-link-deals"
              onClick={(e) => goSection(e, "#deals")}
              className="font-display text-sm font-extrabold uppercase tracking-wide text-cream/80 transition-colors hover:text-sunshine"
            >
              $10 Deals
            </a>
            <a
              href="#contact"
              data-testid="footer-link-contact"
              onClick={(e) => goSection(e, "#contact")}
              className="font-display text-sm font-extrabold uppercase tracking-wide text-cream/80 transition-colors hover:text-sunshine"
            >
              Find Us
            </a>
          </nav>
        </div>

        <p aria-hidden="true" className="text-outline-cream mt-16 select-none whitespace-nowrap text-center font-display text-[16vw] font-black uppercase leading-[0.85]">
          PATTISTA
        </p>

        <div className="mt-6 flex flex-col items-center justify-between gap-3 border-t border-cream/15 pt-6 text-sm text-cream/60 sm:flex-row">
          <p data-testid="footer-copyright">© {new Date().getFullYear()} Pattista. All rights reserved.</p>
          <p>Takeout {BRAND.phoneDisplay} · {BRAND.address}</p>
        </div>
      </div>
    </footer>
  );
}
